// @ts-check

import z from "zod";
import * as Sentry from "@sentry/react";
import { DefaultToolUI, getParsedToolParam, ToolDefinitions } from "./tools";
import { ErrorBoundary} from "react-error-boundary"
import { ToolCallState } from "../tool-call";

/** @type {Map<string, import("./tools").ToolDefinition<z.ZodType, z.ZodType>>} */
const ToolDefinitionsMap = new Map(ToolDefinitions.map((def) => [def.name, def]))

/**
 * @param {Object} props 
 * @param {string} props.name
 * @param {string} props.args
 * @param {string|null} props.result
 */
function ChatBubbleTool(props) {
  return (
    <ErrorBoundary
      fallback={<DefaultToolUI state={ToolCallState.SUCCESS} {...props} />}
      onError={(error, errorInfo) => {
        Sentry.captureException(error, {
          extra: {
            context: 'ChatBubbleTool - error boundary',
            componentStack: errorInfo.componentStack,
            toolName: props.name,
            args: props.args,
            result: props.result
          }
        });
        console.error(error);
      }}
    >
      <ChatBubbleToolComponent {...props} />
    </ErrorBoundary>
  )
}

/**
 * @param {Object} props 
 * @param {string} props.name
 * @param {string} props.args
 * @param {string|null} props.result
 */
function ChatBubbleToolComponent({ name, args, result }) {
  const definition = ToolDefinitionsMap.get(name);
  if(definition == null) {
    throw new Error(`Tool ${name} not found`);
  }

  const parsedArgs = getParsedToolParam(args, definition.argsSchema)
  const parsedResult = getParsedToolParam(result, definition.resultSchema)
  const toolCallState = (() => {
    if(parsedResult instanceof Error) return ToolCallState.ERROR
    if(result == null) return ToolCallState.PENDING
    return ToolCallState.SUCCESS
  })()

  return (
    <definition.Component
      name={name}
      args={parsedArgs}
      result={parsedResult}
      state={toolCallState}
    />
  )
}

export default ChatBubbleTool
